
import { Payload } from "@/types/profile";

export const firewallPayloads: Payload[] = [
  // Firewall payloads
  {
    id: "firewall",
    name: "Firewall",
    description: "Configure macOS firewall settings",
    category: "Security",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "firewallEnabled",
        name: "Enable Firewall",
        type: "boolean",
        required: true,
        default: true,
        description: "Enable the firewall"
      },
      {
        id: "blockAllIncoming",
        name: "Block All Incoming Connections",
        type: "boolean",
        required: false,
        default: false,
        description: "Block all incoming connections"
      },
      {
        id: "stealthMode",
        name: "Enable Stealth Mode",
        type: "boolean",
        required: false,
        default: false,
        description: "Enable stealth mode to prevent response to ICMP requests"
      }
    ]
  }
];
